import { useEffect } from "react"
import useScrollContext from "@/hooks/useScrollContext"

const Loading = ({ children }) => {
	const scroll = useScrollContext()
	useEffect(() => {
		return () => {
			scroll.refresh()
		}
	}, [])
	return children
}
export default Loading
